import { actionConstants } from './actionConstants';
import noti from './toast';
import { get, post, put, _delete } from './method';

export default {
  getMapImage,
  getMapShapes,
  getMapsByDept,
};

function getMapImage(deptId, mapName) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_MAPS });
    return await get(`app/maps/background/${deptId}/${mapName}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_MAP_IMAGE_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_MAP_IMAGE_FAILURE,
          data: error.response.data.error.message,
        });
      });
  };
}

function getMapShapes(deptId, mapName) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_MAPS });
    return await get(`app/maps/mapShapes/${deptId}/${mapName}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_MAP_SHAPES_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_MAP_SHAPES_FAILURE,
          data: error.response.data.error.message,
        });
      });
  };
}

function getMapsByDept(deptId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_MAPS });
    return await get(`app/maps/by-department/${deptId}?MaxResultCount=1000`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_MAPS_BY_DEPT_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_MAPS_BY_DEPT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}
